import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";
import { IVirtualTreeViewDefinition } from "@iconics/providers.fadx-platform-api-client-v2";

export class VirtualTreeView extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public DisplayName = '';
    public Description = '';
    public Definition: IVirtualTreeViewDefinition = {};
    public OntologyId = '';
    public IsEnabled = false;
    public '@odata.etag' = '';

    public init(response: any): ODataSelect
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export class TreeViewRulesDefinition implements IVirtualTreeViewDefinition
{
    Model = "TreeViewRules";
    Data: ITreeViewRulesData = { TreeViewRules: []};

}

export interface ITreeViewRulesData
{
    TreeViewRules: ITreeViewRule[];
}

export interface ITreeViewRule
{
    Id: string;
    RuleType: string;
    FilterType: string;
    FilterValue: string;
    KeepEmptyAssets: boolean;
    UseFullNames: boolean;
    Order: number;
    Name: string;
    OntologyNodeId: string;
    Nested: boolean;
}

export interface IOntology
{
    Name: string;
    IsEnabled: string;
    Id: string;
}

export interface IOntologyNode
{
    Name: string;
    IsEnabled: string;
    DisplayName: string;
    IsRequired: string;
    Id: string;
    IsRecursive: string;
    Parent_ID: string;
    "@odata.etag": string;
}